// extracted by mini-css-extract-plugin
export default {"tableContainer":"o2jL2G5wEEIJFZTv4Q9f","analystName":"FbLc0LmcXJprVh1agxu6"};